import React from 'react';
import EvaluationEmet from './ViewEmet';


const index = (props) => (
    <EvaluationEmet />
);

export default index;